'use client'
import { __awaiter } from '../../../../../../_virtual/_tslib.js';
import { getEnvironmentId, setEnvironmentId } from '../../../../store/state/environmentId.js';

/**
 * Detects envId mismtach with store.
 * @returns true if there is no mismatch.
 */
const handleStoreAndEnvironmentMismatch = (_a) => __awaiter(void 0, [_a], void 0, function* ({ environmentId, logout, }) {
    const storeEnvId = getEnvironmentId();
    if (!storeEnvId || environmentId === storeEnvId) {
        return true;
    }
    yield logout('store and environment are out of sync', {
        currentEnvId: environmentId,
        storedEnvId: storeEnvId,
    });
    setEnvironmentId(environmentId);
    return false;
});

export { handleStoreAndEnvironmentMismatch };
